import { call, put, takeLatest } from "redux-saga/effects";
import { callAPI, handleError, handleSuccess } from "../api/api";
import { setLoaderAction, setNotificationAction } from "../reducers/mmymSlice";

import {
  addReviewAction,
  addReviewSourceAction,
  deleteDefaultServiceAction,
  deleteDefaultTaskAction,
  deleteReviewAction,
  getAllReviwsAction,
  getAllReviwSourceAction,
  getDefaultServiceListAction,
  getDefaultTaskListAction,
  getJobCompletionTaskAction,
  getLeadNotificationAction,
  setAddReviewResponse,
  setAddReviewSourceResponse,
  setAllReviwsAction,
  setAllReviwSourceAction,
  setDefaultServiceListResponse,
  setDefaultTaskListResponse,
  setDeleteReviewResponse,
  setJobCompletionTaskResponse,
  setLeadNotification,
  setUpdateDefaultServiceResponse,
  setUpdateDefaultTaskResponse,
  setUpdateLeadNotificationAction,
  updateCrewLeadNotesAction,
  updatedCrewLeadNotesResponse,
  updateDefaultServiceAction,
  updateDefaultTaskAction,
  updateLeadNotificationAction,
} from "../reducers/reviewSlice";

/**
 * This function for call the user profile
 *
 * @param {*} payload
 */

function* getAllReviwsSaga(action: {
  type: string;
  payload: {
    page: number;
    limit: number;
    orderBy: string;
    orderIn: string;
    roleType?: string;
    search: string;
    status: string;
    leadId?: string;
  };
}): any {
  yield put(setLoaderAction(true));
  const { page, limit, orderBy, orderIn, roleType, search, status, leadId } =
    action.payload;
  try {
    const res = yield call<any>(
      callAPI,
      {},
      "get",
      `leads/customer-reviews?page=${page}&limit=${limit}&orderBy=${orderBy}&orderIn=${orderIn}${leadId ? `&lead_id=${leadId}` : ""}`,
    );
    if (res?.data) {
      yield put(setAllReviwsAction(res?.data));
    }
  } catch (error) {
    console.log("Catch Error-", error);
  }
  yield put(setLoaderAction(false));
}

function* getJobCompletionTaskSaga(action: any): any {
  yield put(setLoaderAction(true));
  const { leadId, status } = action.payload;
  try {
    const res = yield call<any>(
      callAPI,
      {},
      "get",
      `leads/${leadId}/tasks`,
    );
    if (res?.data) {
      yield put(setJobCompletionTaskResponse(res?.data));
    }
  } catch (error) {
    console.log("Catch Error-", error);
  }
  yield put(setLoaderAction(false));
}

function* updateCrewLeadNotesSaga(payload: any[]): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const apiResponse = yield call<any>(
      callAPI,
      payload,
      "post",
      "leads/crew-notes",
    );
    console.log("changePassword-", apiResponse);
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(updatedCrewLeadNotesResponse(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(updatedCrewLeadNotesResponse(false));
  }
  yield put(setLoaderAction(false));
}

function* addReviewSaga(payload: any[]): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const apiResponse = yield call<any>(
      callAPI,
      payload,
      "post",
      "leads/customer-reviews",
    );
    console.log("changePassword-", apiResponse);
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setAddReviewResponse(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setAddReviewResponse(false));
  }
  yield put(setLoaderAction(false));
}


// task
function* getAllReviwSourceSaga(): any {
  yield put(setLoaderAction(true));
  console.log("plans-try");
  try {
    const res = yield call<any>(
      callAPI,
      {},
      "get",
      `client/settings/review-sources`,
    );
    console.log("plans-", res);
    if (res?.data) {
      yield put(setAllReviwSourceAction(res?.data));
    }
  } catch (error) {
    console.log("Catch Error-", error);
  }
  yield put(setLoaderAction(false));
}

function* addReviewSourceSaga(action: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  console.log("addComplaintCostSaga-action-", action);
  const { ...newPayload } = action.payload;
  try {
    const apiResponse = yield call<any>(
      callAPI,
      { payload:newPayload },
      "post",
      `client/settings/review-sources`,
    );
    console.log("addComplaintCostSaga-", apiResponse);
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setAddReviewSourceResponse(true));
      // Refresh the costs list
      // yield put(getComplaintCostsAction({ complaint_id }));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setAddReviewSourceResponse(false));
  }
  yield put(setLoaderAction(false));
}


// delete task
function* deleteReviewSaga(action: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  const { id, complaint_id } = action.payload;
  try {
    const apiResponse = yield call<any>(
      callAPI,
      {},
      "delete",
      `client/settings/review-sources/${id}`,
    );
    console.log("deleteComplaintTask-", apiResponse);
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setDeleteReviewResponse(true));
      // Refresh the task list
      // const startDate = new Date().toISOString().split('T')[0];
      // const endDate = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0];
      // yield put(getComplaintTaskAction({ complaint_id, start: startDate, end: endDate }));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setDeleteReviewResponse(false));
  }
  yield put(setLoaderAction(false));
}

// default service list
function* getDefaultServiceListSaga(): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
     const storedUser = localStorage.getItem("user");
    if (storedUser) {
      const userProfile = JSON.parse(storedUser);
      const userRole = userProfile?.user?.roles;

       let endpoint = "client/default-services";
      if (userRole.includes("CUSTOMER") || userRole.includes("Customer")) {
        endpoint = "customers/default-services";
      }

    const res = yield call<any>(
      callAPI,
      {},
      "get",
      `${endpoint}`,
    );
    if (res?.data) {
      yield put(setDefaultServiceListResponse(res?.data));
    }
  }
  } catch (error) {
    console.log("Catch Error-", error);
  }
  yield put(setLoaderAction(false));
}

// update default service
function* updateDefaultServiceSaga(action: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  const { is_deletable,is_deleted,is_editable,updated_at,updated_by, created_at,created_by, ...newPayload } = action.payload;
  try {
    const apiResponse = yield call<any>(
      callAPI,
      { payload: newPayload },
      "post",
      `client/default-services`,
    );
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setUpdateDefaultServiceResponse(true));
      yield put(getDefaultServiceListAction());
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setUpdateDefaultServiceResponse(false));
  }
  yield put(setLoaderAction(false));
}

// delete default service
function* deleteDefaultServiceSaga(action: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  const { id } = action.payload;
  try {    const apiResponse = yield call<any>(
      callAPI,
      {},
      "delete",
      `client/default-services/${id}`,
    );
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(getDefaultServiceListAction());
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

// default task list
function* getDefaultTaskListSaga(): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const res = yield call<any>(
      callAPI,
      {},
      "get",
      `client/default-tasks`,
    );
    if (res?.data) {
      yield put(setDefaultTaskListResponse(res?.data));
    }
  } catch (error) {
    console.log("Catch Error-", error);
  }
  yield put(setLoaderAction(false));
}

// update default task
function* updateDefaultTaskSaga(action: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
 const { is_deletable,is_deleted,is_editable,updated_at,updated_by, created_at,created_by, ...newPayload } = action.payload;
  try {
    const apiResponse = yield call<any>(
      callAPI,
      { payload: newPayload },
      "post",
      `client/default-tasks`,
    );
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(getDefaultTaskListAction());
      yield put(setUpdateDefaultTaskResponse(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setUpdateDefaultTaskResponse(false));
  }
  yield put(setLoaderAction(false));
}

// delete default task
function* deleteDefaultTaskSaga(action: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  const { id } = action.payload;
  try {    const apiResponse = yield call<any>(
      callAPI,
      {},
      "delete", 
      `client/default-tasks/${id}`,
    );
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(getDefaultTaskListAction());
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

// lead notification
function* getLeadNotificationSaga(action: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const res = yield call<any>(
      callAPI,
      {},
      "get",
      `client/lead-notification-settings`,
    );
    if (res?.data) {
      yield put(setLeadNotification(res?.data));
    }
  } catch (error) {
    console.log("Catch Error-", error);
  }
  yield put(setLoaderAction(false));
}

// update lead notification
function* updateLeadNotificationSaga(action: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  const { is_deletable,is_deleted,is_editable,updated_at,updated_by, created_at,created_by, ...newPayload } = action.payload;
  try {
    const apiResponse = yield call<any>(
      callAPI,
      { payload: newPayload },
      "put",
      `client/lead-notification-settings/${newPayload?.id}`,
    );
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(getLeadNotificationAction());
      yield put(setUpdateLeadNotificationAction(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setUpdateLeadNotificationAction(false));
  }
  yield put(setLoaderAction(false));
}

export function* watchReview() {
  yield takeLatest<any>(getAllReviwsAction, getAllReviwsSaga);
  yield takeLatest<any>(addReviewAction, addReviewSaga);
  yield takeLatest<any>(getJobCompletionTaskAction, getJobCompletionTaskSaga);
  yield takeLatest<any>(getAllReviwSourceAction, getAllReviwSourceSaga);
  yield takeLatest<any>(addReviewSourceAction,addReviewSourceSaga);
 yield takeLatest<any>(updateCrewLeadNotesAction, updateCrewLeadNotesSaga);
  yield takeLatest<any>(deleteReviewAction, deleteReviewSaga);
  yield takeLatest<any>(getDefaultServiceListAction, getDefaultServiceListSaga);
  yield takeLatest<any>(updateDefaultServiceAction, updateDefaultServiceSaga);
  yield takeLatest<any>(deleteDefaultServiceAction, deleteDefaultServiceSaga);
  yield takeLatest<any>(getDefaultTaskListAction, getDefaultTaskListSaga);
  yield takeLatest<any>(updateDefaultTaskAction, updateDefaultTaskSaga);
  yield takeLatest<any>(deleteDefaultTaskAction, deleteDefaultTaskSaga);
  yield takeLatest<any>(getLeadNotificationAction, getLeadNotificationSaga);
  yield takeLatest<any>(updateLeadNotificationAction, updateLeadNotificationSaga);
}
